import type { RestoreResponse } from "client/types";
import { apiClient } from "client/utils";

export type InStoreFieldsRequest = {
  inStoreDirectDebitAuthorized: boolean;
  inStoreTrainingComplete: boolean;
};

export const updateInStoreFields: (
  inStoreFieldsRequest: Partial<InStoreFieldsRequest>
) => Promise<RestoreResponse> = (inStoreFieldsRequest) =>
  apiClient<RestoreResponse>("/api/in-store-fields", {
    data: inStoreFieldsRequest,
  });
